function init() {
    const tabs = document.querySelectorAll(".tab");
    const tabContents = document.querySelectorAll(".content-list");

    if (tabs.length === 0 || tabContents.length === 0) {
        return;
    }

    tabs.forEach(tab => {
        tab.addEventListener("click", () => {
            const target = document.querySelector(tab.dataset.tabTarget);

            tabs.forEach(t => t.classList.remove("active"));
            tabContents.forEach(tc => tc.classList.remove("active"));

            tab.classList.add("active");
            target.classList.add("active");

            tab.scrollIntoView({
                behavior: "smooth",
                block: "nearest",
                inline: "center"
            });
        });
    });
}

export default { init };
